import Button from '@ui/Button';
import Input from '@ui/Input';
import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import { defaults, pick } from 'lodash-es';

const schema = yup.object().shape({
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long'),
  confirmPassword: yup
    .string()
    .required('Confirm Password is required')
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});

function NonProfitOnBoardFormCredentialStep(props) {
  const { onSubmit, formData } = props;

  const defaultValues = defaults(
    pick(formData, ['password', 'confirmPassword']),
    {
      password: '',
      confirmPassword: '',
      email: 'test@example.com',
    }
  );
  const form = useForm({
    defaultValues: defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
  } = form;

  const handleFormSubmit = async (data) => {
    onSubmit(data);
  };

  return (
    <div className="flex flex-col gap-12 flex-1 w-full">
      <Typography variant="dialogtitle">Welcome to NEKI</Typography>

      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="flex flex-col gap-6">
        <Controller
          name="password"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="Password"
              required
              {...rest}
              error={errors.password?.message}
            />
          )}
        />

        <Controller
          name="confirmPassword"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="Confirm Password"
              required
              {...rest}
              error={errors.confirmPassword?.message}
            />
          )}
        />

        <Controller
          name="email"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="Email Id"
              disabled
              {...rest}
              error={errors.email?.message}
            />
          )}
        />

        <div className="flex justify-end flex-rows gap-4">
          <div className="flex-flow-col">
            <Button
              variant="filled"
              color="primary"
              type="submit"
              className="mt-2">
              Next
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NonProfitOnBoardFormCredentialStep;
